<div class="inspections">
  <p class="main-case"></p>

  <table class="data-table">
    <thead>
      <tr>
        <td
          colspan="4"
          style="
            border-bottom: none;
            text-align: center;
            font-weight: bold;
            font-size: 20px;
            font-style: italic;
            padding-top: 10px;
          "
        >
          תקן 1001 - חלק 1.1 - בטיחות אש בבניינים:
        </td>
      </tr>
      <tr>
        <td
          colspan="4"
          style="
            border-top: none;
            text-align: center;
            font-weight: bold;
            font-size: 18px;
            padding-bottom: 10px;
          "
        >
          מערכות מיזוג אוויר ואוורור - תכנון / התקנה
        </td>
      </tr>
      <tr>
        <th style="width: 10%">
          <strong>הסעיף הנבדק</strong>
        </th>
        <th style="width: 43%">
          <strong>דרישת התקן</strong>
        </th>
        <th style="width: 10%">
          <strong>התאמה לתקן</strong>
        </th>
        <th style="width: 37%">
          <strong>הערות</strong>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of cases">
        <td class="section">
          <span [class.underline]="item.isTitle">{{ item.section }}</span>
        </td>
        <td>
          <span [class.underline]="item.isTitle">{{ item.title }}</span>
        </td>
        <td>
          <span>{{ getConclusion(item) }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of item.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
      </tr>
    </tbody>
  </table>

  <authority-labs-summary-notes
    [summaryNotes]="inspection?.summaryNotes"
    [root]="true"
  ></authority-labs-summary-notes>
</div>
